import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Bell, CheckCircle, CloudOff, Info, Plus } from 'react-feather'
import { useRemote, useStorage } from '../../Utils/Utils'
import { NotificationsContext, PAGES, ROUTE_PATHS } from "../../InternalApiApp";
import { useWebsockets } from '../../Utils/WebsocketReceiverHook'
import { useHistory } from 'react-router-dom'
import { format } from 'date-fns'
import Logo from '../../layouts/Shared/Logo/Logo'
import Button from '../Buttons/Button'
import NewMenu from './NewMenu'
import Popup from '../Popup'
import ProfileMenu from './ProfileMenu'
import ProfileImage from '../ProfileImage'
import LoadingIcon from '../LoadingIcon';
import StatusWidget from './StatusWidget'
import ConfirmOptionModal from '../Modals/ConfirmOptionModal'
import NotificationMenu from './Notifications/NotificationMenu'
import CFSLogo from '../../images/colonial-first-state.png'
import './TopBar.scss'

import SwitchCompanyModal from '../Modals/SwitchCompanyModal'

const TopBar = ({ topMessage, setSwitchingCompany, isExternalManager }) => {
	const [profileMenuOpen] = useState(false);
	const [showConfirmOptionModal, setShowConfirmOptionModal] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const [showSwitchCompanyModal, setShowSwitchCompanyModal] = useState(false);

	const { setActiveNotification } = useContext(NotificationsContext);

	const remote = useRemote();
	const storage = useStorage();
	const history = useHistory();
	const sockets = useWebsockets();

	const [me, setMe] = useState(null);
	const [tenants, setTenants] = useState([]);

	const getNotifications = useCallback(async function getNotifications() {
		await remote.get(`notification/message`).then((response) => {
			setNotifications(response);
		}).catch((error) => {
			console.error("Front end encountered an error getting the notificaions: ", error);
		});
	}, [remote]);

	useEffect(() => {
		storage.getOrFetch("/crm/me").then(setMe);
		storage.refresh("/crm/tenants").then((fetchedTenants) => {
			const sortedTenants = fetchedTenants.sort((a, b) => {
				const tenant1 = a.isBookmarked ? 1 : 0
				const tenant2 = b.isBookmarked ? 1 : 0
				return tenant2 - tenant1
			})
			setTenants(sortedTenants)
		});
	}, [])

	useEffect(() => {
		getNotifications();
		sockets.subscribe({
			"/api/notification/message": [() => getNotifications()]
		})
		return () => sockets.unsubscribe(["/api/notification/message"]);

	}, [getNotifications]);


	const getMessageComponent = () => {
		const { noDocument, saving, lastSaved, error } = topMessage;

		if (topMessage) {
			return (
				<StatusWidget
					icon={noDocument ? <Info /> : saving ? <LoadingIcon variant="light" size={20} /> : lastSaved ? <CheckCircle className="colour-text-positive" /> : error ? <CloudOff /> : ""}
					label={noDocument ? "No document loaded" : saving ? "Saving to 3SKYE…" : lastSaved ? "Save Complete:" : error ? "Save Unavailable:" : ""}
					message={lastSaved ? format(lastSaved, "hh:mm aaa, dd MMM yyyy ") : error ? "Network Lost" : ""}
					status={error && !saving ? "danger" : ""}
				/>
			);
		}
		return null;
	}

	const synchroniseData = () => {
		remote.post("/data/synchronise")
	}

	function markAsRead(notificationMsgReceiverId, unread) {
		remote.post(`notification/${unread ? 'unread' : 'read'}/${notificationMsgReceiverId}`).then(() => {
			getNotifications()
		}).catch(() => null)
	}

	return (<>
		<div className="top-bar colour-bg-accent-2" >
			{showConfirmOptionModal &&
				<ConfirmOptionModal
					header="Data Synchronisation"
					message="Select which data you would like to synchronise:"
					handleClose={() => setShowConfirmOptionModal(false)}
					cancelButton={{ onClick: () => setShowConfirmOptionModal(null) }}
					confirmButton={{ variant: "positive", label: "Sync Data", onClick: () => { synchroniseData(); setShowConfirmOptionModal(false) } }}
					options={[{ label: "Fund Fact Sheet", checked: true, onClick: () => null, disabled: true }, { label: "Quarterly Fund Update", checked: false, onClick: () => null, disabled: true }]}
				/>
			}
			{showSwitchCompanyModal &&
				<SwitchCompanyModal
					handleClose={() => setShowSwitchCompanyModal(false)}
					confirmButton={{ onClick: () => setShowSwitchCompanyModal(false), label: "Close", noPadding: true }}
					tenants={tenants}
					user={me}
					setTenants={setTenants}
				/>
			}
			<div className="top-bar-left-container">
				{isExternalManager && <img style={{ marginRight: '1.5rem', height: '1.5rem' }} src={CFSLogo} />}
				<Logo className="top-bar-logo" onClick={() => {
					history.push(ROUTE_PATHS[PAGES.LIBRARY])
				}}
				/>
			</div>
			{topMessage && getMessageComponent()}
			<div className="top-bar-right-container">
				<Popup
					className="mr-l"
					triggerElement={
						<div style={{ position: "relative" }}>
							<Bell color="white" />
							{notifications.filter(n => !n.readAt).length > 0 &&
								<div className="notification-badge">
									<p>{notifications.filter(n => !n.readAt).length}</p>
								</div>
							}
						</div>
					}
					popupElement={<NotificationMenu notifications={notifications} markAsRead={markAsRead} setActiveNotification={setActiveNotification} />}
					placement='bottom'
					offsetY={6}
					hoverOnly
				/>
				{me && me.perms.includes("EDIT") && <Popup
					className="mr-l"
					triggerElement={<Button noHover className="top-bar-new-Button" onClick={() => history.push(ROUTE_PATHS[PAGES.EDITOR])} icon={<Plus />} >New</Button>}
					popupElement={<NewMenu crmPath={ROUTE_PATHS[PAGES.CRM]} editorPath={ROUTE_PATHS[PAGES.EDITOR]} changeRoute={(url) => history.push(url)} setShowConfirmOptionModal={setShowConfirmOptionModal} />}
					hoverOnly
					offsetY={4}
				/>}
				<Popup
					triggerElement={<ProfileImage focused={profileMenuOpen} user={me} src={me && ("data:image/jpeg;base64," + me.photo)} />}
					popupElement={<ProfileMenu changeRoute={(url) => history.push(url)} user={me} tenants={tenants} setSwitchingCompany={setSwitchingCompany} setShowSwitchCompanyModal={setShowSwitchCompanyModal} />}
					hoverOnly
				/>
			</div>
		</div>
	</>)
};

export default TopBar;